import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';


export class HttpResult<T> {
  result: T;
  error: any;
}

@Injectable()
export class ApiHttpService {

  constructor(private http: HttpClient) {
  }

  public get<T>(url: string, options?: any): Observable<HttpResult<T>> {
    return new Observable<HttpResult<T>>((observer) => {
      return this.http.get<T>(url, options).subscribe((res) => {
        observer.next({result: <any>res, error: undefined});
        observer.complete();
      }, err => {
        observer.next({result: undefined, error: err});
      });
    });
  }

  public post<T>(url: string, data: any, options?: any): Promise<T> {
    return new Promise((resolve, reject) => {
      this.http.post<T>(url, data, options).subscribe((result) => {
        resolve(<any>result);
      }, (error) => {
        reject(error);
      });
    });
  }

  public put(url: string, data: any, options?: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.put(url, data, options).subscribe((result) => {
        resolve(<any>result);
      }, (error) => {
        reject(error);
      });
    });
  }

  public delete(url: string, options?: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.delete(url, options).subscribe((result) => {
        resolve(result);
      }, (error) => {
        reject(error);
      });
    });
  }
}
